import { ITEM_TYPES, SECONDS_IN_A_MINUTE } from '../../config/constants';
import { contracts } from '../../config/blockchain';
import Log from '../../utils/Log';
import moment from 'moment';

export const FETCH_AUCTION_ITEMS = 'FETCH_AUCTION_ITEMS';

export const fetchAuctionItems = () => async (dispatch, getState) =>
  contracts.stickItemTypeAuction.getAuctionIds((error, auctions) => {
    if (!error) {
      Log.info(`Auctions count: ${auctions.length}.`);

      Promise.all(auctions.map(auction => {
        return new Promise((resolve, reject) => {
          contracts.stickItemTypeAuction.getAuctionInfo(auction, (error, auctionInfo) => {
            if (auctionInfo) {
              const startTime = auctionInfo[5].toNumber();
              const endTime = auctionInfo[6].toNumber();
              const timeNow = moment().unix();
              const timeRemaining = endTime - timeNow;
              const tenMinsInFuture = timeNow + (SECONDS_IN_A_MINUTE * 10);

              if (timeRemaining > 0 && startTime < tenMinsInFuture) { // Filter expired and auctions starting in over ten minutes
                const uri = auctionInfo[1];

                window.fetch(uri).then((response) => {
                  response.json().then((schema) => {
                    resolve({
                      type: ITEM_TYPES.AUCTION,
                      id: auction.toNumber(),
                      typeId: auctionInfo[0].toNumber(),
                      uri: uri,
                      startPrice: auctionInfo[2].toNumber(),
                      endPrice: auctionInfo[3].toNumber(),
                      currentPrice: auctionInfo[4].toNumber(),
                      startTime: startTime,
                      endTime: endTime,
                      schema: schema
                    });
                  }).catch((error) => {
                    Log.error(`Failed when trying to parse JSON. ${error}.`);
                    resolve(false); // Always resolve - Promise.all is all or nothing
                  });
                }).catch((error) => {
                  Log.error(`Failed when trying to fetch JSON. ${error}.`);
                  resolve(false);
                });
              } else {
                resolve(false);
              }
            } else {
              resolve(false);
            }
          });
        });
      })).then(auctionItems => {
        dispatch({
          type: FETCH_AUCTION_ITEMS,
          payload: auctionItems.filter(Boolean) // Remove resolve(false) from array
        });
      });
    } else {
      Log.error(`Failed when tried to get AuctionItems ${error}.`);
    }
  });



// WEBPACK FOOTER //
// ./src/redux/actions/auctionItemsActions.js